import { render, staticRenderFns } from "./Woven_Roll_Stock.vue?vue&type=template&id=46804a1c&scoped=true"
import script from "./Woven_Roll_Stock.vue?vue&type=script&lang=js"
export * from "./Woven_Roll_Stock.vue?vue&type=script&lang=js"
import style0 from "./Woven_Roll_Stock.vue?vue&type=style&index=0&id=46804a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46804a1c",
  null
  
)

export default component.exports